import { connect } from 'react-redux';

import { getPayments, cancelPayment, getPaymentsInvoice, resendPaymentConfirmationMessage } from '../../_redux';
import { PaymentsConfirmationPanel } from '../../_components';

export default connect(
  state => ({
    payments: state.client.payments.paymentsInfo,
    loading: state.client.payments.loadingPayments,
    cancelPaymentLoading: state.client.payments.cancelPaymentLoading,
    isConfirmationMessageResent: state.client.payments.isConfirmationMessageResent,
    confirmationMessageIsSending: state.client.payments.confirmationMessageIsSending,
    redirect: state.client.common.redirect,
    addons: state.interfaceConfig.addons,
    profile: state.user.profile,
  }),
  {
    loadPayments: id => getPayments.request(id),
    cancelPayment: id => cancelPayment.request(id),
    getPaymentsInvoice: id => getPaymentsInvoice.request(id),
    resendPaymentConfirmationMessage: id => resendPaymentConfirmationMessage.request(id),
  }
)(PaymentsConfirmationPanel);
